import { useState } from "react";
import { useEffect } from "react";
import Ticker from "react-ticker";
import { retrieveStockCurrentPrice } from "../../Services/StockSessionApiService";
import { useAuthHeader } from "../../auth/AuthService";
import { useTranslation } from "react-i18next";

export default function StockScroller({ STATE, EXCHANGERATE }) {
  const [stocks, setStocks] = useState();
  const authHeader = useAuthHeader();

  async function getAllStockCurrentPrice() {
    await retrieveStockCurrentPrice(authHeader())
      .then((response) => {
        let data = response.data.data;
        setStocks(data);
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    getAllStockCurrentPrice();
    const intervalCurrentPrice = setInterval(getAllStockCurrentPrice, 5000);

    if (STATE == 99 || new Date().setHours(15, 10, 0) < new Date().getTime()) {
      clearInterval(intervalCurrentPrice);
    }

    return () => {
      clearInterval(intervalCurrentPrice);
    };
  }, [STATE]);

  if (stocks) {
    return (
      <Ticker offset="run-in">
        {({ index }) => (
          <span className="text-nowrap white-space-nowrap pr-1">
            <Stocks data={stocks} exchangeRate={EXCHANGERATE}></Stocks>
          </span>
        )}
      </Ticker>
    );
  }
}

function Stocks({ data, exchangeRate }) {
  const { t } = useTranslation();

  let mbStock = [];
  let gbStock = [];
  data.sort((a, b) => (a.icode > b.icode ? 1 : -1));
  data.map((stock) => {
    if (stock.board_type == "M") {
      mbStock.push(stock);
    } else {
      gbStock.push(stock);
    }
  });

  return (
    <span>
      {/* Exchange Rate */}
      <span className="font-bold">
        {t("Exchange Rate")} :
        <span className="text-yellow-500 font-bold font-italic px-2">
          {exchangeRate} KHR / USD &nbsp; -
        </span>
      </span>

      {/* Main Board */}
      <span className="text-white font-bold pr-1">{t("Main Board")} : </span>
      <span className="text-yellow-500 font-bold font-italic">
        {mbStock.map((stock, i) => {
          let data = stock;
          let img = "";
          if (data) {
            if (data.sq) {
              if (data.change > 0) {
                if (data.price == data.upperPrice) {
                  img = (
                    <img
                      className="change-arrow"
                      src="/img/sq_upper_sign.png"
                    />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/sq_up_sign.png" />
                  );
                }
              } else if (data.change < 0) {
                if (data.price == data.lowerPrice) {
                  img = (
                    <img
                      className="change-arrow"
                      src="/img/sq_lower_sign.png"
                    />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/sq_low_sign.png" />
                  );
                }
              } else {
                img = (
                  <img className="change-arrow" src="/img/unchange_sign.png" />
                );
              }
            } else {
              if (data.change > 0) {
                if (data.price == data.upperPrice) {
                  img = (
                    <img className="change-arrow" src="/img/upper_sign.png" />
                  );
                } else {
                  img = <img className="change-arrow" src="/img/up_sign.png" />;
                }
              } else if (data.change < 0) {
                if (data.price == data.lowerPrice) {
                  img = (
                    <img className="change-arrow" src="/img/lower_sign.png" />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/low_sign.png" />
                  );
                }
              } else {
                img = (
                  <img className="change-arrow" src="/img/unchange_sign.png" />
                );
              }
            }
          }

          return (
            <span key={i}>
              {stock.symbol.trim() + " " + stock.price} {img}{" "}
              {" (" +
                Intl.NumberFormat("en-US", {
                  notation: "compact",
                  maximumFractionDigits: 2,
                }).format(stock.qty) +
                " Sh)"}
              &nbsp;&nbsp;-&nbsp;&nbsp;
            </span>
          );
        })}
      </span>

      {/* Growth Board */}
      <span className="text-white font-bold pr-1">{t("Growth Board")} : </span>
      <span className="text-yellow-500 font-bold font-italic">
        {gbStock.map((stock, i) => {
          let data = stock;
          let img = "";
          if (data) {
            if (data.sq) {
              if (data.change > 0) {
                if (data.price == data.upperPrice) {
                  img = (
                    <img
                      className="change-arrow"
                      src="/img/sq_upper_sign.png"
                    />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/sq_up_sign.png" />
                  );
                }
              } else if (data.change < 0) {
                if (data.price == data.lowerPrice) {
                  img = (
                    <img
                      className="change-arrow"
                      src="/img/sq_lower_sign.png"
                    />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/sq_low_sign.png" />
                  );
                }
              } else {
                img = (
                  <img className="change-arrow" src="/img/unchange_sign.png" />
                );
              }
            } else {
              if (data.change > 0) {
                if (data.price == data.upperPrice) {
                  img = (
                    <img className="change-arrow" src="/img/upper_sign.png" />
                  );
                } else {
                  img = <img className="change-arrow" src="/img/up_sign.png" />;
                }
              } else if (data.change < 0) {
                if (data.price == data.lowerPrice) {
                  img = (
                    <img className="change-arrow" src="/img/lower_sign.png" />
                  );
                } else {
                  img = (
                    <img className="change-arrow" src="/img/low_sign.png" />
                  );
                }
              } else {
                img = (
                  <img className="change-arrow" src="/img/unchange_sign.png" />
                );
              }
            }
          }

          return (
            <span key={i}>
              {stock.symbol.trim() + " " + stock.price} {img}{" "}
              {" (" +
                Intl.NumberFormat("en-US", {
                  notation: "compact",
                  maximumFractionDigits: 2,
                }).format(stock.qty) +
                " Sh)"}
              &nbsp;&nbsp;-&nbsp;&nbsp;
            </span>
          );
        })}
      </span>
    </span>
  );
}
